var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluild":""}},[_c('TabViews',{attrs:{"vertical":false,"centered":false,"tabs":_vm.helpTabs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }